"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.SvgIconArchive = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _react = _interopRequireDefault(require("react"));

var SvgIconArchive = function SvgIconArchive(props) {
  return /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/_react.default.createElement("path", {
    d: "M11.25 1H0.75C0.335789 1 0 1.33581 0 1.75V3.25H12V1.75C12 1.33581 11.6642 1 11.25 1Z",
    fill: "currentColor"
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M0.75 10.7502C0.75 11.1642 1.08574 11.5 1.49988 11.5H10.5001C10.9143 11.5 11.25 11.1642 11.25 10.7502V4H0.75V10.7502ZM4.875 5.5H7.125C7.53921 5.5 7.875 5.83581 7.875 6.25C7.875 6.66419 7.53921 7 7.125 7H4.875C4.46079 7 4.125 6.66419 4.125 6.25C4.125 5.83581 4.46079 5.5 4.875 5.5Z",
    fill: "currentColor"
  }));
};

exports.SvgIconArchive = SvgIconArchive;